import { useState, useEffect } from 'react';
import { useFlipperExperimentBucketQueryLazyQuery, useWeddingWebsiteQuery } from '../../generated/graphql';

export const usePublishModalRegistryExp = () => {
  const [callFlipperAssignment, { data: flipperData, error }] = useFlipperExperimentBucketQueryLazyQuery();
  const { data: wwsData } = useWeddingWebsiteQuery();
  const [isVariant, setIsVariant] = useState<boolean | undefined>(undefined);
  const variantName = flipperData?.flipperExperimentBucket?.variant_name;

  const isUserEmailVerified = wwsData?.member?.isEmailVerified || false;
  const memberId = wwsData?.member?.id || '';
  const isWebsitePublished = wwsData?.weddingWebsite?.state === 'published';

  const shouldRenderPublishWebsiteModal = isUserEmailVerified && isWebsitePublished;

  useEffect(() => {
    const bucketExperiment = async () => {
      if (!memberId || !shouldRenderPublishWebsiteModal || variantName === 'control' || error !== undefined) {
        setIsVariant(false);
        return;
      }
      if (variantName === 'variant') {
        setIsVariant(true);
        return;
      }
      await callFlipperAssignment({
        variables: {
          flipperExperimentBucketExperimentId: process.env.REACT_APP_FLIPPER_PUBLISH_MODAL_REG_EXP_ID as string,
          flipperExperimentBucketId: memberId as string,
        },
      });
      return;
    };
    bucketExperiment();
  }, [callFlipperAssignment, variantName, memberId, shouldRenderPublishWebsiteModal, error]);

  return { isVariant };
};
